import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import BusinessIcon from "@material-ui/icons/Business";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { changeStepper } from "../../../actions/preAfiliado/stepper";
// import MuiAlert from "@material-ui/lab/Alert";
import { Redirect } from "react-router-dom";
// import { fetchAportes } from "../../actions/aportes";
import { AfiliadoTurno } from "./AfiliadoTurno";
import { NuevoTurno } from "./NuevoTurno";
import { DetallesTurno } from "./DetallesTurno";
import { agendaLimpiar, confirmarTurno, fetchDiasAgenda } from "../../../actions/turnos/agenda";
import { BannerAfiliado } from "../../afiliaciones/BannerAfiliado";
import { ModalMultiSesion } from "./ModalMultiSesion";
import { BuscadorParaTurnos } from "../../afiliaciones/BuscadorParaTurnos";
import { OBRAS_SOCIALES, TIPO_TURNO } from "../../../utils/constants";
import { fetchCodNomAutor } from "../../../actions/contrataciones/configuraciones/ambCosegurosExternosActions";
import { FormatListBulleted } from '@material-ui/icons';
import { FormularioCoseguro } from '../coseguros/FormularioCoseguro';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SearchIcon />,
    2: <GroupAddIcon />,
    3: <BusinessIcon />,
    4: <FormatListBulleted />,
    5: <AssignmentIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
    marginLeft: 25,
  },
  button: {
    marginRight: theme.spacing(10),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    margin: 30,
  },
  rootListadoc: {
    margin: 30,
  },
  practicas: {
    padding:10,
    marginTop: 15,
    backgroundColor: theme.palette.background.paper,
  }
}));

function getSteps() {
  return [
    "Búsqueda",
    "Datos Afiliado",
    "Parametros",
    "Prácticas",
    "Confirmacion",
  ];
}

export default function StepperTurnos({ fromBandeja, desdeHce, idOS, idEfectorHce, cerrarHce }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [presencial, setPresencial] = useState(true);
  const [virtual, setVirtual] = useState(true);
  const [idCentroMedico, setIdCentroMedico] = useState(null);
  const [idEspecialidad, setIdEspecialidad] = useState(null);
  const [idProfesional, setIdProfesional] = useState(desdeHce ? idEfectorHce : null);
  const [primeroDisponible, setPrimeroDisponible] = useState(false);
  const [filtrarEdad, setFiltrarEdad] = React.useState(true);

  const [redirect, setRedirect] = React.useState(false);
  const [otroTurno, setOtroTurno] = React.useState(false);
  const [abrirModalMultiSesion, setAbrirModalMultiSesion] = useState(false);

  const { step } = useSelector((state) => state.stepper);
  const { seleccionado, afiliado } = useSelector((state) => state.afiliacion);
  const { seleccionado: turnoSeleccionado } = useSelector((state) => state.agenda);
  const [idObraSocial, setIdObraSocial] = useState(desdeHce ? idOS : null);

  const btnRef = useRef(null);

  const steps = getSteps();

  const esMultiSesion = false;

  const closeModalMultiSesionHandler = () => {
    setAbrirModalMultiSesion(false);
  }

  const handleInputChange = ({ target }) => {
    switch (target.name) {
      case 'idEspecialidad':
        setIdEspecialidad(target.value);
        setIdCentroMedico(null);
        setIdProfesional(null);
        dispatch(agendaLimpiar());
        break;
      case 'idCentroMedico':
        setIdCentroMedico(target.value);
        break;
      case 'idProfesional':
        if (target.value === '')
          setIdProfesional(null);
        else
          setIdProfesional(target.value);
        break;
      default:
        break;
    }
  }

  const handleInputChangePorProfesional = ({ target }) => {
    switch (target.name) {
      case 'idProfesional':
        setIdProfesional(target.value);
        setIdCentroMedico(null);
        setIdEspecialidad(null);
        dispatch(agendaLimpiar());
        break;
      case 'idCentroMedico':
        setIdCentroMedico(target.value);
        break;
      case 'idEspecialidad':
        setIdEspecialidad(target.value);
        break;

      default:
        break;
    }
  }

  const resetDefaultValues = () => {
    setPresencial(true);
    setVirtual(true);
    setIdEspecialidad(null);
    setIdCentroMedico(null);
    setIdProfesional(null);
    setPrimeroDisponible(false);
    setFiltrarEdad(true);
  }

  const handleNext = () => {
    switch (step) {
      case 0:
        dispatch(changeStepper(step + 1));
        setOtroTurno(false);
        break;
      case 1:
        document.querySelector(`#btnSubmitDatosTurnos`).click();
        resetDefaultValues();
        break;
      case 2:
        if (idObraSocial === OBRAS_SOCIALES.OSOCNA) {
          dispatch(fetchCodNomAutor(turnoSeleccionado?.efectorRed?.idEfectorRed, turnoSeleccionado?.especialidad?.idEspecialidades, turnoSeleccionado?.centroMedico?.idCentroMedico))
        }        
        dispatch(
          changeStepper(
            step + (
              turnoSeleccionado.idTipoTurno === TIPO_TURNO.PRESENCIAL && !turnoSeleccionado.especialidad.exentoCoSeguro
                ? 1 
                : 2
              )
          )
        );
        break;
      case 3:        
        btnRef.current.click();
        break;
      case 4:
        dispatch(confirmarTurno(turnoSeleccionado.idAgenda, afiliado.id_afiliado, turnoSeleccionado.idTipoTurno, afiliado.carnet, setRedirect, afiliado.idAfiliadoExterno));
        if (esMultiSesion) {
          setAbrirModalMultiSesion(true);
        }
        if (desdeHce){
          cerrarHce();
        }
        break;
      default:
        break;
    }
  };

  const handleNextOtroTurno = () => {
    dispatch(confirmarTurno(turnoSeleccionado.idAgenda, afiliado.id_afiliado, turnoSeleccionado.idTipoTurno, afiliado.carnet, null, afiliado.idAfiliadoExterno));
    if (esMultiSesion) {
      setAbrirModalMultiSesion(true);
    }
    dispatch(changeStepper(2));
    setOtroTurno(true);
  }

  const handleBack = () => {
    dispatch(changeStepper(step - ((step === 4 && (turnoSeleccionado.idTipoTurno === TIPO_TURNO.VIRTUAL || turnoSeleccionado.especialidad.exentoCoSeguro)) ? 2 : 1)));
    if (((step === 3) || (step === 4 && turnoSeleccionado.idTipoTurno === TIPO_TURNO.VIRTUAL)) && !primeroDisponible)
      dispatch(fetchDiasAgenda(idEspecialidad, idCentroMedico, idProfesional, presencial, virtual));
  };

  const handleChangeFiltrarEdad = (value) => {
    setFiltrarEdad(value);
    handleInputChange({ target: { name: 'idEspecialidad', value: null } });
  }

  const getStepContent = (escalon) => {
    switch (escalon) {
      case 0:
        return (
          <Grid item xs={12} sm={10} md={6}>
            <BuscadorParaTurnos consultaTurnos={true} idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} />
          </Grid>
        );
      case 1:
        return (
          <Grid item xs={12} sm={10} md={6}>
            <AfiliadoTurno idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} />
          </Grid>
        );
      case 2:
        return (
          <Grid item xs={12} sm={10} md={6} style={{ marginTop: 30 }} >
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <BannerAfiliado turnos={true} />
            </div>
            <NuevoTurno
              otroTurno={otroTurno}
              setOtroTurno={setOtroTurno}
              presencial={presencial}
              setPresencial={setPresencial}
              virtual={idObraSocial === OBRAS_SOCIALES.OSPEDYC ? virtual : false}
              setVirtual={setVirtual}
              filtrarEdad={filtrarEdad}
              idEspecialidad={idEspecialidad}
              idCentroMedico={idCentroMedico}
              idProfesional={idProfesional}
              primeroDisponible={primeroDisponible}
              handleInputChange={handleInputChange}
              setPrimeroDisponible={setPrimeroDisponible}
              handleChangeFiltrarEdad={handleChangeFiltrarEdad}
              handleInputChangePorProfesional={handleInputChangePorProfesional}
              idObraSocial={idObraSocial}
              desdeHce={desdeHce}
            />
          </Grid>
        );
      case 3:
        return (
          <Grid item xs={12} sm={10} md={6} className={classes.practicas} >
            <FormularioCoseguro
              changeSteppetTurnos={() => dispatch(changeStepper(step + 1))}
              usuarioTurnoSeleccionado={turnoSeleccionado}
              idAgenda={seleccionado?.idAgenda}
              idObraSocial={idObraSocial}
              pantallaTurnos={true}
              btnRef={btnRef}
            />
          </Grid>
        )
      case 4:
        return (
          <Grid item xs={12} sm={10} md={6}>
            <DetallesTurno idObraSocial={idObraSocial} />
          </Grid>
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={step}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <ModalMultiSesion open={abrirModalMultiSesion} onClose={closeModalMultiSesionHandler} />
      <div>
        <Grid container justify="center">
          {getStepContent(step)}
        </Grid>
        {seleccionado &&
          <Grid
            className={classes.buttonRoot}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            {step !== 0 && !(desdeHce && step === 2) &&
              <Button
                variant="contained"
                disabled={step === 0}
                onClick={handleBack}
                className={classes.button}
                color="secondary"
              >
                Anterior
              </Button>
            }
            {(step === 1 && afiliado.fecha_baja !== null) || (step === 2 && (turnoSeleccionado === null || turnoSeleccionado?.idTipoTurno === 3))
              ?
              null
              :
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
                disabled={afiliado.sinFichaAfiliacion ? true : false}
              >
                {step === steps.length - 1 ? "Confirmar" : "Siguiente"}
              </Button>
            }
          </Grid>
        }
        {seleccionado && step === steps.length - 1 &&
          <Grid
            className={classes.buttonRoot}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleNextOtroTurno}
              className={classes.button}
            >
              Confirmar y sacar otro
            </Button>
          </Grid>
        }
      </div>
      {redirect && !desdeHce && (
        <Redirect
          to={{
            pathname: "/turnos",
          }}
        />
      )}
    </div>
  );
}